import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import styles from './styles.module.scss'

// data: [{ label, to? }] — пункт с `to` рендерится ссылкой, без `to` — текущий пункт.
const BreadCrumbs = ({ data = [] }) => {
  return (
    <div className={styles.breadcrumbs}>
      {data.map((item, i) => (
        <Fragment key={i}>
          {i > 0 && <span className={styles.separator}>/</span>}
          {item.to
            ? <Link to={item.to} className={styles.link}>{item.label}</Link>
            : <span>{item.label}</span>}
        </Fragment>
      ))}
    </div>
  )
}

export default BreadCrumbs
